// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"0c3325d3","222":"b46f03db","766":"df458ff1","884":"e56db57f"}[chunkId] + ".chunk.js";
};